module.exports = __webpack_public_path__ + "media/images/lb/589-d330b9b915a8d3446fe8f69a40e47015.svg";